import { Provider } from "react-redux";
import store from "./store/configureStore"
import { RouterProvider, BrowserRouter } from "react-router-dom";
// import router from "./routes";
import AppRouter from "./routes"
import { ConfigProvider, theme } from "antd";
import ErrorBoundary from "./components/ErrorBoundary";
import "antd/dist/reset.css";


function App() {
    const { defaultAlgorithm } = theme;
    // const [isDarkMode, setIsDarkMode] = useState(false);
    return (
        <>
            <ConfigProvider
                theme={{
                    // algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm,
                    algorithm: defaultAlgorithm,
                    components: {},
                    token: {
                        fontFamily: "'Inter', sans-serif",
                    }
                }}
            >
                <ErrorBoundary handleLogout={() => { }}>
                    <Provider store={store}>
                           <BrowserRouter>
                            {/* <RouterProvider router={router} /> */}
                              <AppRouter />
                            </BrowserRouter>
                    </Provider>
                </ErrorBoundary>
            </ConfigProvider>

        </>
            );
        }
        
        export default App;
